import { CopyToClipboard } from 'react-copy-to-clipboard';
import { ICON_COLOR } from '@zep-us/zus/tokens';
import Link from 'next/link';
import { useTranslation } from 'next-i18next';
import { useJoinWithLocale, useTemporaryBooleanState } from '@/hooks';
import { CheckSmallIcon, ExportIcon, SquareStackIcon } from '@/icons';
import { Button } from '@/ui_v3';
import { cn } from '@/utils/tailwind.util';
const JoinLinkButton = () => {
  const {
    t
  } = useTranslation(['common']);
  const localePath = useJoinWithLocale();
  return <Button asChild intent="neutral" variant="outlined" size="sm" rounded="full" className="w-fit" data-sentry-element="Button" data-sentry-component="JoinLinkButton" data-sentry-source-file="EnterCodeSection.tsx">
      <Link href={localePath('/join')} target="_blank" data-sentry-element="Link" data-sentry-source-file="EnterCodeSection.tsx">
        {t('shareModal.title')}
        <ExportIcon size="xs" fill={ICON_COLOR.neutral} className="ml-3xs" data-sentry-element="ExportIcon" data-sentry-source-file="EnterCodeSection.tsx" />
      </Link>
    </Button>;
};
interface EnterCodeProps {
  enterCode: string | number;
  /** 입장 코드 복사 시도 결과. 공유 수단 계측은 모달이 소유한다. */
  onCodeCopied?: (succeeded: boolean) => void;
}
interface EnterCodeSectionProps extends EnterCodeProps {
  obscured?: boolean;
}
export const EnterCode = ({
  enterCode,
  onCodeCopied
}: EnterCodeProps) => {
  const [isEnterCodeCopied, setIsEnterCodeCopied] = useTemporaryBooleanState(false, 2000);
  return <div className="text-display-md-extrabold text-strong" data-sentry-component="EnterCode" data-sentry-source-file="EnterCodeSection.tsx">
      <CopyToClipboard text={enterCode.toString()} onCopy={(_text, succeeded) => {
      onCodeCopied?.(succeeded);
      if (succeeded) setIsEnterCodeCopied(true);
    }} data-sentry-element="CopyToClipboard" data-sentry-source-file="EnterCodeSection.tsx">
        <span className="group relative cursor-pointer">
          <span className="group-hover:opacity-[0.72]">{enterCode}</span>
          <div className="absolute right-[-25px] top-[30%]">
            {isEnterCodeCopied ? <CheckSmallIcon size="sm" fill={ICON_COLOR.strong} /> : <div className="opacity-0 group-hover:opacity-100">
                <SquareStackIcon size="sm" fill={ICON_COLOR.alternative} />
              </div>}
          </div>
        </span>
      </CopyToClipboard>
    </div>;
};
export const EnterCodeSection = ({
  obscured,
  ...props
}: EnterCodeSectionProps) => {
  return <div className={cn('flex w-full flex-shrink-0 flex-col items-center gap-0.5 text-center', obscured && 'blur-[8px]')} data-sentry-component="EnterCodeSection" data-sentry-source-file="EnterCodeSection.tsx">
      <JoinLinkButton data-sentry-element="JoinLinkButton" data-sentry-source-file="EnterCodeSection.tsx" />
      <EnterCode {...props} data-sentry-element="EnterCode" data-sentry-source-file="EnterCodeSection.tsx" />
    </div>;
};